import { Component, OnInit, Input, forwardRef } from '@angular/core';

import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { RootService } from '../../service/root.service';

@Component({

    selector: 'aFormYesNo,[aFormYesNo]',
    templateUrl: './aFormYesNo.component.html',
    styleUrls: ['./aFormYesNo.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormYesNoComponent, multi: true },
    ]
})
export class AFormYesNoComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() cClass;
    @Input() icon;
    @Input() disabled;
    value;
    _onChange = (value: any) => { };

    registerOnChange(fn) {
        this._onChange = fn;
    }

    registerOnTouched() { }
    writeValue(value: any) {
        this.value = value;
    }

    constructor(public rootService:RootService) {
        
     }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormYesNo/aFormYesNo.component.ts